import React from 'react';

import { NewBadgeLabel } from 'components/modules/badge/NewBadgeLabel';

import ShinroArticleCard, { ShinroArticleCardProps } from './ShinroArticleCard';
import CSSModule from './ShinroSection.module.scss';

type ShinroSectionProps = {
  title: string;
  articles: ShinroArticleCardProps[];
  currentRelease: boolean;
};

const ShinroSection: React.FC<ShinroSectionProps> = ({
  title,
  articles,
  currentRelease,
}) => (
  <section className={CSSModule.ShinroSection}>
    <h2 className={CSSModule.ShinroSection__Title}>
      {currentRelease && <NewBadgeLabel />}
      <div className={CSSModule.ShinroSection__Title__TitleText}>{title}</div>
    </h2>
    <div className={CSSModule.ShinroSection__Articles}>
      {articles.map((article, idx) => (
        <ShinroArticleCard key={idx} {...article} />
      ))}
    </div>
  </section>
);

export default ShinroSection;
